/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default [
    {
        path: '/form-types',
        name: 'FormTypes',
        component: () => import('@/views/Form/FormTypes.vue'),
        meta: { anyPermission: ['form-types.create', 'form-types.update', 'form-types.delete'] }
    },
    {
        path: '/form-types/:id',
        name: 'FormTypeDetail',
        component: () => import('@/views/Form/FormTypeDetail.vue'),
        meta: { anyPermission: ['form-types.create', 'form-types.update', 'form-types.delete'] }
    },
    {
        path: '/forms',
        name: 'Forms',
        component: () => import('@/views/Form/Forms.vue'),
        meta: { permission: 'forms.view' }
    },
    {
        path: '/forms/create/select-type',
        name: 'FormTypeSelect',
        component: () => import('@/views/Form/FormTypeSelect.vue'),
        meta: { permission: 'forms.create' }
    },
    {
        path: '/forms/create',
        redirect: { name: 'FormTypeSelect' }
    },
    {
        path: '/forms/builder',
        name: 'CustomFormBuilder',
        component: () => import('@/views/Form/CustomFormBuilder.vue'),
        meta: { permission: 'forms.create' }
    },
    {
        path: '/forms/:formId/builder',
        name: 'CustomFormBuilderEdit',
        component: () => import('@/views/Form/CustomFormBuilder.vue'),
        meta: { permission: 'forms.update' }
    },
    {
        path: '/forms/:id',
        name: 'Form',
        component: () => import('@/views/Form/Form.vue'),
        meta: { permission: 'forms.view' }
    },
    {
        path: '/forms/:formId/edit',
        name: 'EditForm',
        component: () => import('@/views/Form/CustomFormBuilder.vue'),
        meta: { permission: 'forms.update' }
    },
    {
        path: '/post/create/forms/:id/wizard',
        name: 'FormWizard',
        component: () => import('@/views/Form/FormWizard.vue'),
        meta: { permission: 'posts.create' }
    },
    {
        path: '/forms/:id/app/create',
        name: 'CreateApplications',
        component: () => import('@/views/Form/FormApplications.vue'),
        meta: { permission: 'forms.create' }
    },
    {
        path: '/forms/:id/app/:reference/edit',
        name: 'EditApplications',
        component: () => import('@/views/Form/FormApplications.vue'),
        meta: { permission: 'forms.update' }
    }
]
